<template>
    <div v-loading="loading" 
        element-loading-text="登录中"
        element-loading-spinner="el-icon-loading"
        class="cont login">
    </div>
</template>

<script>
    import { getQr, getOpenId, login, refreshToken } from "network/login.js"
    import { checkRealName } from "network/application.js"
    export default {
        data(){
            return {
                loading: true,
                type:'',
                scope:'',
                redirectUri: encodeURI(process.env.VUE_APP_BASE_URL + "/login"),
                nodeEnv: process.env.NODE_ENV,
            }
        },
        created(){
            console.log(this.nodeEnv,this.redirectUri)
            if(this.$IsMobile()){
                this.type = 'wx';
                this.scope = "snsapi_userinfo";
            }else{
                this.type = 'pc';
                this.scope = "snsapi_login";
            };
            if (this.nodeEnv == 'development'){
                // 线下测试
                this.testLogin()
            }else{
                if(this.code){
                    this.getOpenIdData();
                }else{
                    this.getQrData();
                }
            }
        },
        methods: {
            // 获取code
            getQrData(){
                let data = {
                    redirectUri:this.redirectUri,
                    scope:this.scope,
                    type:this.type,
                }
                getQr(data).then(res =>{
                    if(this.type =="wx"){
                        window.location.href = res.data;
                    }else{
                        this.$router.push({path:'/qrCode',query:{link:res.data}})
                    }
                })
            },

            // 通过code获取openid
            getOpenIdData(){
                let data = {
                    code:this.code,
                    type:this.type
                }
                getOpenId(data).then(res =>{
                    if(res.code == 1){
                        this.$store.dispatch('getLogin',
                            {
                                access_token:res.data.access_token,
                                openid:res.data.openid,
                                refresh_token:res.data.refresh_token,
                            }
                        )
                        setTimeout(()=>{
                            this.loginData()
                        },500)
                    }else{
                        // 当code过期
                        this.getQrData()
                    }
                })
            },

            // 微信登录
            loginData(){
                login({
                    accessToken:this.$store.state.access_token,
                    openid:this.$store.state.openid,
                    type:this.type
                }).then(res=>{
                    if(res.code == 1){
                        localStorage['sessionid'] = res.data
                        this.$message({
                            type:'success',
                            message:'登录成功',
                        })
                       
                        this.getRefreshToken()
                        setTimeout(()=>{
                            this.getCheckRealName()
                        },1500)
                    }else{
                        this.$message({
                            type:'error',
                            message:res.msg
                        })
                    }
                })
            },
            // token刷新
            getRefreshToken(){
                refreshToken({
                    openid:this.$store.state.openid,
                    type:this.type,
                    refresh_token:this.$store.state.refresh_token,
                }).then(res=>{
                    if(res.code == 1){
                        // console.log("微信token刷新成功")
                    }
                })
            },

            // 查真实姓名及手机号是否填写
            getCheckRealName(){
                checkRealName().then(res=>{
                    if(res.code == 1){
                        let lastLink = sessionStorage.getItem('lastLink')
                        if(lastLink && lastLink.indexOf('/login') == -1 ){
                            window.location.href = lastLink;
                        }else{
                            this.$router.push('/index')
                        }
                    }else if(res.code == 2){
                        this.$router.push('/profile?flag=login')
                        this.$message({
                            type:'error',
                            message:'请先填写用户信息'
                        })
                    }
                })
            },

            // 临时本地登录
            testLogin(){
                this.$store.dispatch('getLogin',{
                    access_token:"41_OjE_DbkjRiUOHz5YvfroeSzKd3uU_f5cOAJm827inypPl9qmnhea0VgoWoZZ5ecHguV808A4keSiOknPb5iAgAcBj-relIL_ayk5LaiqWv4",
                    openid:"oOaiH52hPoY3R19ki9LqVfJpBQM4",
                    refresh_token:"41_ybMIumol3cloFoK0WxWxIi9M8AkyOSo7_B12mRgGevvnQq-KvkqfuWxLP-U5UCAz5_FzwLDKA5lh1rfyUuIdXDT_M-IWNJ-Soto-HzOJIjs",
                    isLogin:true
                });
                setTimeout(()=>{
                    this.loginData()
                },1500)
            }
        },
        computed:{
            code(){
                return this.$route.query.code ? this.$route.query.code : ""
            },
            state(){
                return this.$route.query.state ? this.$route.query.state : ""
            },
        }
    }
</script>
<style scoped>
    .cont{
        height: 60vh;
    }
    
</style>